import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

// HELP
import LeftSection from './help/LeftSection';

// STYLES
import { WelcomeContainer } from './styles';

const SMImg = getS3ImageUrl('/partner-streaming-tv-welcome-updated2.png', '/cp-uploads');

const Welcome = ({ isIframe, partner }) => {
  return (
    <WelcomeContainer className="welcome" isIframe={isIframe}>
      <div className="page-content welcome__content">
        <Grid container spacing={4} justifyContent="space-between" alignItems="center">
          <Grid item xs={12} sm={7} md={7} lg={7}>
            <LeftSection partner={partner} />
          </Grid>
          <Grid item xs={12} sm={5} md={5}>
            <div className="welcome__img">
              <img src={SMImg} alt="welcome" />
            </div>
          </Grid>
        </Grid>
      </div>
    </WelcomeContainer>
  );
};

Welcome.propTypes = {
  isIframe: PropTypes.bool.isRequired,
  partner: PropTypes.object.isRequired,
};

export default React.memo(Welcome);
